import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchFields = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_FIELDS),
    shouldCallAPI: state => state.settings.fields._forceFetch,
    callAPI: {
        url: '/api/settings/fields'
    }
});